import { styled } from '@mui/material';
import { IconButton, Button, Link } from 'core/common/ui/ui-kit';
import Icon from 'core/svg-sprites/ui/Icon';

export const ContainerStyled = styled('div')`
  width: 312px;
  height: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};
`;

export const CloseButtonStyled = styled(IconButton)`
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-bottom: 20px;
`;

export const CloseIconStyled = styled(Icon)`
  width: 16px;
  height: 16px;
  fill: ${({ theme }) => theme.palette.text.primary};
`;

export const NavLinkStyled = styled(Link)`
  display: block;
  margin-bottom: 10px;
`;

export const ButtonStyled = styled(Button)`
  margin-bottom: 10px;
`;
